<template>
  <nna-container>
    <form novalidate class="md-layout" @submit.prevent="onSubmitForm">
             
      <h1 class="md-title">Compila i seguenti campi</h1>

      <div class="md-layout md-gutter">
        <div class="md-layout-item md-size-20" v-show="showPrefix">
          <md-field>
            <label for="telephone">Telefono</label>
            <md-select v-model="form.prefix" name="prefix" id="prefix">
              <md-option value="+39">+39</md-option>
              <md-option value="+44">+44</md-option>
            </md-select>
          </md-field>
        </div>
        <div class="md-layout-item">
          <md-field :class="getValidationClass('username')">
            <label for="username" v-show="showUsernameLabel">Telefono o email</label>
            <label for="username" v-show="showTelephone">Email</label>
            <md-input name="username" id="username" autocomplete="username" v-model="form.username" :disabled="sending" />
            <span class="md-error" v-if="!$v.form.username.required">Inserisci la tua username</span>
            <span class="md-error" v-else-if="!$v.form.username.email">Username non valida</span>
          </md-field>
        </div>
      </div>

      <md-field :class="getValidationClass('firstname')">
        <label for="first-name">Nome</label>
        <md-input name="first-name" id="first-name" autocomplete="name" v-model="form.firstname" :disabled="sending" />
        <span class="md-error" v-if="!$v.form.firstname.required">Inserisci il tuo nome</span>
        <span class="md-error" v-else-if="!$v.form.firstname.minlength">Nome non valido</span>
      </md-field>

      <md-field :class="getValidationClass('lastname')">
        <label for="first-name">Cognome</label>
        <md-input name="last-name" id="last-name" autocomplete="lastname" v-model="form.lastname" :disabled="sending" />
        <span class="md-error" v-if="!$v.form.lastname.required">Inserisci il tuo Cognome</span>
        <span class="md-error" v-else-if="!$v.form.lastname.minlength">Cognome non valido</span>
      </md-field>

      <md-field :class="getValidationClass('email')" v-if="showEmail">
        <label for="email">Email</label>
        <md-input type="email" name="email" id="email" autocomplete="email" v-model="form.email" :disabled="sending" />
        <span class="md-error" v-if="!$v.form.email.required">Inserisci la tua email</span>
        <span class="md-error" v-else-if="!$v.form.email.email">Email non valida</span>
      </md-field>

      <div class="md-layout md-gutter" v-if="showTelephone">
        <div class="md-layout-item md-size-20">
          <md-field>
            <label for="telephone">Telefono</label>
            <md-select v-model="form.prefix" name="prefix" id="prefix">
              <md-option value="+39">+39</md-option>
              <md-option value="+44">+44</md-option>
            </md-select>
          </md-field>
        </div>
        <div class="md-layout-item">
          <md-field :class="getValidationClass('telephone')">            
            <md-input name="telephone" id="telephone" autocomplete="name" v-model="form.telephone" :disabled="sending" type="phone" />
            <span class="md-error" v-if="!$v.form.telephone.required">inserisci il tuo numero di telefono</span>
            <span class="md-error" v-else-if="!$v.form.telephone.minlength">Numero non valido</span>
          </md-field>
        </div>
      </div>

      <md-field :class="getValidationClass('password')">
        <label for="first-name">Password</label>
        <md-input name="password" id="password" autocomplete="password" v-model="form.password" :disabled="sending" type="password"/>
        <span class="md-error" v-if="!$v.form.password.required">Inserisci la tua password</span>
        <span class="md-error" v-else-if="!$v.form.password.minlength">Password non valido</span>
      </md-field>

      <md-field :class="getValidationClass('mpassword')">
        <label for="mpassword">Conferma Password</label>
        <md-input name="mpassword" id="mpassword" autocomplete="mpassword" v-model="form.mpassword" :disabled="sending" type="password"/>
        <span class="md-error" v-if="!$v.form.mpassword.required">Inserisci la tua password</span>
        <span class="md-error" v-else-if="!$v.form.mpassword.minlength">Password non valido</span>
        <span class="md-error" v-else-if="!$v.form.mpassword.sameAsPassword">La password non coicidono</span>
      </md-field>    
      
      <md-progress-bar md-mode="indeterminate" v-if="sending" />

      <div :class="getValidationPrivacy">
        <md-checkbox v-model="form.tnc" value="1"></md-checkbox>
        <a class="terms" href="https://skiply.it/terms-and-conditions" target="_blank">Accetto i termini e condizioni del servizio</a>
      </div>

      <md-button type="submit" class="md-raised md-primary" md-align="center" :disabled="sending">Registrati</md-button>
    </form>
  </nna-container>
</template>

<script>
import CMM from '@nonameapp-core'
import { mapActions } from 'vuex'
export default {
  name: 'Signup',
  mixins: [
    CMM._mixins.form("signUp")
  ],
  data() {
    return {
      userSaved: false,
      showTelephone: false,
      showEmail: false,
      showPrefix: false,
      form: {
        email: '',
        telephone: '',
        prefix: '+39',
        firstname: '',
        lastname: '',        
        password: '',
        mpassword: '',
        activation: 'mail',
        tnc: "0",        
      }
    }
  },
  watch: {
    'form.username': {
      handler(val){
        this.checkUserName(val)
      },
      deep: true
    }
  },
  computed: {
    getValidationPrivacy() {
      return {
        ['valid'] : this.form.tnc === '1'
      }
    },
    showUsernameLabel() {
      return !this.showPrefix && !this.showTelephone
    },
    isPhoneActivation() {
      return this.form.activation === "phone"
    },
    username() {
      return this.isPhoneActivation ? `${this.form.prefix}${this.form.username}` : this.form.username
    }
  },
  methods: {
    ...mapActions({
      signUp: "auth/signUp",
    }),
    checkUserName (val) {       
      const email = this.regex.email;
      const phone = this.regex.phone;
      if(email.test(String(val).toLowerCase())) {
        this.showTelephone = true
        this.showEmail = false
        this.showPrefix = false
        this.form.activation = "mail"
        this.form.email = this.form.username
      }
      else if(phone.test(String(val).toLowerCase())) {
        this.showTelephone = false
        this.showEmail = true
        this.showPrefix = true
        this.form.activation = "phone"
        this.form.telephone = this.form.username
      }
      else {
        this.showTelephone = false
        this.showEmail = false
        this.showPrefix = false
        this.form.activation = "mail"
      }
    },
    onSubmitForm () {
      if(this.validateForm()) {
        if(this.form.tnc === "1") {
          this.saveUser()
        } else {

        }
      }
      
    },
    toGo() {
      if(this.form.activation === 'phone') {
        this.$router.push({ name: "signup.verifyNumber", params: { username: this.username } })
      } else {
        this.$router.push({ name: "signup.done" })
      }
    },  
    async saveUser() {
      this.sending = true
      try { 
        const { data } = await this.signUp(this.form)
        if(data.hcode === "ok") {
          this.sending = false
          this.toGo()
          this.clearForm()
        } else {
          this.sending = false
          this.$toasted.show(data.msg, { type: 'error' })
        }        
     } catch (errors) {
       console.error("Error:", errors)
       this.sending = false
       this.$toasted.show('Qualcosa è andato storto!', { type: 'error' })
      }
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
  .md-progress-bar {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
  }
  .terms {
    position: relative;
    top: -5px;
  }
</style>



// WEBPACK FOOTER //
// src/modules/auth/signup/pages/Signup.vue